<template>
    <v-container fluid>
        <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="purple--text"></v-progress-circular>

        <h1>Authorization callback for {{provider}} ...</h1>
    </v-container>

</template>

<script>
    export default {
        name: 'callback',
        props: {
            provider: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                title: 'Login callback',
            };
        },
        created() {
            this.$store.dispatch('profile/SAVE_CONNECTION', { ProviderId: this.provider, Query: this.$route.query })
                .then(() => this.$router.replace({ path: '/me' }))
                .catch(error => this.$store.commit('errors/ADD', error, { root: true }));
        },
    };
</script>



// WEBPACK FOOTER //
// CallbackProvider.vue?cb551892